import { jsxs, jsx } from "react/jsx-runtime";
import { c as classNames } from "../../../../index-e71f83b5.js";
import { useWindowSize } from "../../../../hooks/useWindowSize/useWindowSize.js";
import { sass } from "../../../../sass/sass.js";
import "../../../../_commonjsHelpers-0c53d963.js";
import "react";
import "../../../../hooks/useWindowSize/WindowSizeContext.js";
import "../../../../utils/noOp.js";
import "../../../../isObject-ec23ace2.js";
import "../../../../isSymbol-c6f5cd95.js";
function FlashModalTitle(props) {
  const { title, Icon } = props, { windowIsMobile } = useWindowSize();
  return /* @__PURE__ */ jsxs("div", { className: "d-flex gap-flashd-013 align-items-center", children: [
    Icon && windowIsMobile && /* @__PURE__ */ jsx("span", { className: "ms-n2", children: /* @__PURE__ */ jsx(
      Icon,
      {
        height: sass.typography.flash.semantic.font.heading.xl3.size,
        width: sass.typography.flash.semantic.font.heading.xl3.size
      }
    ) }),
    title && /* @__PURE__ */ jsx("h2", { className: "fs-body-l fw-bold mb-n1", children: title })
  ] });
}
function FlashModalHorizontalRule(props) {
  const { windowIsMobile } = useWindowSize(), defaultMargin = windowIsMobile ? "3" : "4", { marginTop = defaultMargin, marginBottom = defaultMargin } = props;
  return /* @__PURE__ */ jsx("hr", { className: classNames("mx-n3", "mx-sm-n4", `mt-${marginTop}`, `mb-${marginBottom}`) });
}
export {
  FlashModalHorizontalRule,
  FlashModalTitle
};
//# sourceMappingURL=FlashModalUtils.js.map
